import "core-js/stable";
import "regenerator-runtime/runtime.js";
import cssVars from 'css-vars-ponyfill';

import "normalize.css";
import "../../ui/src/reset.scss";
import "../../new_ui/src/style.scss"

import App from "./App.svelte";

cssVars();

const app = new App({
	target: document.body,
});

export default app;
